import { z } from "zod/v3";

import type { IdAndLabel } from "@workspace/shared/types";

export * from "./currencies/types";

export const Money = z.object({
	value: z.coerce.number(),
	currency: z.string(),
	version: z.literal(2),
});
export type Money = z.infer<typeof Money>;

export const StudentOutstandingBalance = z.object({
	amountDue: Money,
});
export type StudentOutstandingBalance = z.infer<
	typeof StudentOutstandingBalance
>;

export interface Source {
	id: string;
	type: string;
	label: string;
}

export interface Amount {
	value: number;
	currency: string;
}

export interface TransactionItem {
	id: string;
	label: string | null | undefined;
	account: string;
	group: string;
	date: string;
	amount: Amount;
	source: Source;
}

export interface AccountGroup {
	account: string;
	total: number;
	items: TransactionItem[];
}

export interface TransactionGroup {
	group: string;
	type: {
		id: string;
		accountGroup: string;
		type: "Inbound" | "Outbound";
		label: string;
	};
	amount: number;
	items: AccountGroup[];
}

export interface AccountsData {
	items: TransactionGroup[];
}

// Constants for account types
export const ACCOUNT_TYPES = {
	INCOME: "Income",
	PAYROLL: "Payroll",
	EXPENSE: "Expense",
} as const;

// Constants for account names
export const ACCOUNT_NAMES = {
	WISE: "wise",
	CASH: "cash",
	REVOLUT: "revolut",
	OTHER: "other",
} as const;

export type OutstandingInvoice = {
	id: string;
	label: string;
	amountDue: Money;
	date: string;
	owner: IdAndLabel;
	source: {
		id: string;
		key: string;
	};
	status:
		| "Pending"
		| "Confirmed"
		| "PendingPayment"
		| "Cancelled"
		| "Overdue"
		| "Paid";
};
